import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroBanner } from './components/HeroBanner';
import { BookOnline } from './components/BookOnline';
import { OurServices } from './components/OurServices';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { SEOHead } from './components/SEOHead';
import { OrganizationSchema, WebsiteSchema } from './components/StructuredData';
import { DevModePanel } from './components/DevMode/DevModePanel';
// Lazy load below-fold homepage components to reduce initial bundle
const HousekeepingRevolution = lazy(() => import('./components/HousekeepingRevolution').then(m => ({
  default: m.HousekeepingRevolution
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const WhyChooseUs = lazy(() => import('./components/WhyChooseUs').then(m => ({
  default: m.WhyChooseUs
})));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy').then(m => ({
  default: m.PrivacyPolicy
})));
const FAQPage = lazy(() => import('./pages/FAQPage').then(m => ({
  default: m.FAQPage
})));
const AboutUs = lazy(() => import('./pages/AboutUs').then(m => ({
  default: m.AboutUs
})));
const ContactUs = lazy(() => import('./pages/ContactUs').then(m => ({
  default: m.ContactUs
})));
const BasicHomeCleaning = lazy(() => import('./pages/BasicHomeCleaning').then(m => ({
  default: m.BasicHomeCleaning
})));
const CommercialCleaning = lazy(() => import('./pages/CommercialCleaning').then(m => ({
  default: m.CommercialCleaning
})));
const CommercialQuote = lazy(() => import('./pages/CommercialQuote').then(m => ({
  default: m.CommercialQuote
})));
const BasicHomeCleaningQuote = lazy(() => import('./pages/BasicHomeCleaningQuote').then(m => ({
  default: m.BasicHomeCleaningQuote
})));
const SpringDeepCleaningQuote = lazy(() => import('./pages/SpringDeepCleaningQuote').then(m => ({
  default: m.SpringDeepCleaningQuote
})));
const MoveInMoveOutQuote = lazy(() => import('./pages/MoveInMoveOutQuote').then(m => ({
  default: m.MoveInMoveOutQuote
})));
const AirbnbQuote = lazy(() => import('./pages/AirbnbQuote').then(m => ({
  default: m.AirbnbQuote
})));
const PostRenovationQuote = lazy(() => import('./pages/PostRenovationQuote').then(m => ({
  default: m.PostRenovationQuote
})));
const SpringDeepCleaning = lazy(() => import('./pages/SpringDeepCleaning').then(m => ({
  default: m.SpringDeepCleaning
})));
function HomePage() {
  return <div className="min-h-screen w-full font-sans bg-white" data-id="element-0">
      <SEOHead title="Smith & Jengs Cleaning Services | Professional Cleaning in Bicester & Oxfordshire" description="Professional residential and commercial cleaning services in Bicester and Oxfordshire. Eco-friendly products, vetted cleaners, online booking, and 100% satisfaction guarantee." canonical="https://smithandjengs.com/" data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroBanner data-id="element-3" />
      <BookOnline data-id="element-4" />
      <OurServices data-id="element-5" />
      <HousekeepingRevolution data-id="element-6" />
      <FAQ data-id="element-7" />
      <WhyChooseUs data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}
export function App() {
  return <Router data-id="element-10">
      <div className="relative" data-id="element-11">
        <OrganizationSchema data-id="element-12" />
        <WebsiteSchema data-id="element-13" />
        <DevModePanel data-id="element-14" />
        <Suspense fallback={<div className="min-h-screen w-full flex items-center justify-center bg-white" data-id="element-16">
              <div className="w-10 h-10 border-4 border-[#1a2744] border-t-[#e91e8c] rounded-full animate-spin" data-id="element-17" />
            </div>} data-id="element-15">
          <Routes data-id="element-18">
            <Route path="/" element={<HomePage data-id="element-20" />} data-id="element-19" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-22" />} data-id="element-21" />
            <Route path="/faq" element={<FAQPage data-id="element-24" />} data-id="element-23" />
            <Route path="/about-us" element={<AboutUs data-id="element-26" />} data-id="element-25" />
            <Route path="/contact-us" element={<ContactUs data-id="element-28" />} data-id="element-27" />
            <Route path="/basic-home-cleaning" element={<BasicHomeCleaning data-id="element-30" />} data-id="element-29" />
            <Route path="/commercial-cleaning" element={<CommercialCleaning data-id="element-32" />} data-id="element-31" />
            <Route path="/commercial-cleaning-quote" element={<CommercialQuote data-id="element-34" />} data-id="element-33" />
            <Route path="/basic-home-cleaning-quote" element={<BasicHomeCleaningQuote data-id="element-36" />} data-id="element-35" />
            <Route path="/spring-deep-cleaning-quote" element={<SpringDeepCleaningQuote data-id="element-38" />} data-id="element-37" />
            <Route path="/move-in-move-out-quote" element={<MoveInMoveOutQuote data-id="element-40" />} data-id="element-39" />
            <Route path="/airbnb-quote" element={<AirbnbQuote data-id="element-42" />} data-id="element-41" />
            <Route path="/post-renovation-quote" element={<PostRenovationQuote data-id="element-44" />} data-id="element-43" />
            <Route path="/spring-deep-cleaning" element={<SpringDeepCleaning data-id="element-46" />} data-id="element-45" />
          </Routes>
        </Suspense>
        <CookieConsent data-id="element-47" />
      </div>
    </Router>;
}